const useTriggerEarliestAfter = () => {
    return (started:number, duration: number, cb: () => void) => {
        const now = new Date().getTime()
        const elapsed = now-started
        if (elapsed < duration) {
            setTimeout(() => {
                cb()
            }, duration-elapsed)
            return
        }
        cb()
    }
}

export default useTriggerEarliestAfter
